import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { Col } from 'react-bootstrap'

import { otpSignMethods, VideoIdSigningOtpMethod } from '../../../constants/videoIdValues'
import { DefaultSpinner } from '../Spinners'

interface Props {
	loading: boolean
	isOtpRetry: boolean
	selectedOtpMethod: VideoIdSigningOtpMethod
	onSelectMethod: (method: VideoIdSigningOtpMethod) => void
	onSendCode: () => void
}

export const VideoIdOtpMethodSelection = ({
	loading,
	isOtpRetry,
	selectedOtpMethod,
	onSelectMethod,
	onSendCode,
}: Props) => {
	const { t } = useTranslation()

	const visibleMethods = otpSignMethods.filter(
		(m) => m.show && (isOtpRetry || m.otpDistributionChannel === VideoIdSigningOtpMethod.SMS),
	)
	const isActive = (method: VideoIdSigningOtpMethod) => method === selectedOtpMethod

	return (
		<div className="sign-pn-otp-sign-method-select">
			<div>{t('SelectOtpMethodDescription')}</div>
			{loading ? (
				<Col xs={12}>
					<DefaultSpinner />
				</Col>
			) : (
				<>
					<div className="otp-select-btn-section">
						{visibleMethods.map((otpButton) => {
							const active = isActive(otpButton.otpDistributionChannel)
							return (
								<div
									key={otpButton.otpDistributionChannel}
									id={`sign-promissory-note-${otpButton.className}-method-button`}
									className={`otp-method-btn${active ? ' active' : ''}`}
									onClick={() => onSelectMethod(otpButton.otpDistributionChannel)}>
									<img
										src={active ? otpButton.iconActive : otpButton.iconInactive}
										className={otpButton.className}
										alt={`${otpButton.className} icon`}
									/>
									<Trans t={t} i18nKey={otpButton.title}>
										Button <wbr /> name
									</Trans>
								</div>
							)
						})}
					</div>
					<div className="send-otp-button-section">
						<button
							id="sign-promissory-note-send-code-button"
							type="button"
							className="btn btn-primary"
							disabled={selectedOtpMethod === VideoIdSigningOtpMethod.Unknown}
							onClick={() => setTimeout(onSendCode, 400)}>
							{t('OtpSend')}
						</button>
					</div>
				</>
			)}
		</div>
	)
}
